import { YearScroller, MonthScroller } from "./scroller.js";


export class DateSelect {

   constructor(settings) {

      let defaults = {
         showStatus: false,
         confirm: false,
         range: false,
         onSelect: (from, to) => {},
         closeOnSelect: false
      };

      this.set = Object.extend(true, defaults, settings);
      this.enabled = true;

      //this.elMain = document.querySelector('#tpl-select-date').content.cloneNode(true);

      this.elMain = HTMLElement.createFromHTML(
         '<div class="date-select">'
       + '   <div class="select">'
       + '      <div class="year">'
       + '         <i class="btn btn-change-year prev icon-arrow-left"></i>'
       + '         <div class="current-year"></div>'
       + '         <i class="btn btn-change-year next icon-arrow-right"></i>'
       + '      </div>'
       + '      <div class="month">'
       + '         <i class="btn btn-change-month prev icon-arrow-left"></i>'
       + '         <div class="current-month"></div>'
       + '         <i class="btn btn-change-month next icon-arrow-right"></i>'
       + '      </div>'
       + '   </div>'
       + '   <div class="confirm">'
       + '      <div class="date">Datum</div>'
       + '      <div class="selected-date"></div>'
       + '      <div class="date-from">Beginn</div>'
       + '      <div class="selected-date"></div>'
       + '      <div class="date-to">Ende</div>'
       + '      <div class="selected-date"></div>'
       + '      <button class="btn-confirm"></button>'
       + '   </div>'
       + '</div>'
      );

      this.elBtnPrevMonth = this.elMain.querySelector('.btn-change-month.prev');
      this.elBtnNextMonth = this.elMain.querySelector('.btn-change-month.next');
      this.elBtnPrevYear = this.elMain.querySelector('.btn-change-year.prev');
      this.elBtnNextYear = this.elMain.querySelector('.btn-change-year.next');

      this.elCurrentYear  = this.elMain.querySelector('.current-year');
      this.elCurrentMonth = this.elMain.querySelector('.current-month');
      this.elMonthTitle   = this.elMain.querySelector('.month-title');

      this.elConfirm = this.elMain.querySelector('.confirm');


      if ((!this.set.confirm && !this.set.range) || !this.set.showStatus) this.elConfirm.style.display = 'none';
      if (this.set.range) {
         this.elMain.querySelector('.confirm .date').style.display = 'none';
      }
      else {
         this.elMain.querySelector('.confirm .date-from').style.display = 'none';
         this.elMain.querySelector('.confirm .date-to').style.display = 'none';
      }

      this.selectedDate = { from: false, to: false };

      const date = new Date();
      this.currentMonth = { year: date.getFullYear(), month: date.getMonth() };
      //this.renderMonth();

      this.yearScroller = new YearScroller({}, this);
      this.elCurrentYear.appendChild(this.yearScroller.getElement());

      this.monthScroller = new MonthScroller({}, this);
      this.monthScroller.setCurrentDate(new Date());
      this.elCurrentMonth.appendChild(this.monthScroller.getElement());

      this.elBtnNextMonth.onclick = event => this.monthScroller.scroll(-1);
      this.elBtnPrevMonth.onclick = event => this.monthScroller.scroll(1);

      this.elBtnNextYear.onclick = event => this.yearScroller.scroll(-1);
      this.elBtnPrevYear.onclick = event => this.yearScroller.scroll(1);
      //this.updateStatus();
      

   }

   setOption(option, value) {
      this.set[option] = value;
   }

   changeYear(year) {
      this.yearScroller.setCurrentYear(year);
   }

   changeMonth(year) {
      let d = new Date(year, this.monthScroller.currentDate.getMonth(), 1);
      this.monthScroller.setCurrentDate(d);
   }

   select(dateFrom, dateTo, triggerSelect=false) {
      this.selectedDate.from = dateFrom;
      this.selectedDate.to   = this.set.range ? dateTo : dateFrom;
      if (this.selectedDate.from.getTime() === this.selectedDate.to.getTime()) this.selectedDate.to = false;
      this.monthScroller.setCurrentDate(dateFrom);

      this.renderSelection(this.monthScroller.getCurrentElement());
      if (triggerSelect && this.set.onSelect) this.set.onSelect(dateFrom, dateTo);
   }

   renderMonth(element) {

      this.elDayGrid = element.querySelector('.day-grid');

      let monthDate = new Date(Date.fromString(element.dataset.date));
      //let date = new Date(this.monthScroller.currentDate.getFullYear(), this.monthScroller.currentDate.getMonth(), 1);

      element.querySelector('.month-title').innerHTML = monthDate.getGermanMonthName();

      this.elDayGrid.empty();
      const dayMap = {};
      let today = new Date();

      let date = new Date(monthDate);
      let weekday = (date.getDay() + 6) % 7;
      date.setDate(1 - weekday);
      let cntDays = 0;


      for (let i=0; i<7; ++i) {
         let elDayTitle = this.elDayGrid.createElement('div', 'weekday-title');
         elDayTitle.style.gridArea = '1 / ' + (i+1);
         elDayTitle.innerHTML = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'][i];
      }

      while (cntDays < 42) {
         let col = (date.getDay() + 6) % 7 + 1;
         let row = Math.floor(cntDays/7) + 2;

         dayMap[date.isoDate()] = { col: col, row: row };

         let elDay = this.elDayGrid.createElement('div', 'weekday' + (date.getMonth() === monthDate.getMonth() ? '' : ' additional'));
         elDay.style.gridArea = `${row} / ${col}`;
         elDay.innerHTML = date.getDate();
         if (date.getFullYear() == today.getFullYear() && date.getMonth() == today.getMonth() && date.getDate() == today.getDate()) elDay.classList.add('today');
         let d = new Date(date);
         elDay.onclick = () => this.onSelect(element, d);
         date.setDate(date.getDate()+1);
         cntDays++;
      }

      element.setData('dayMap', dayMap);

      //this.updateStatus();
      this.renderSelection(element);

   }

   renderSelection(element) {

      const elDayGrid = element.querySelector('.day-grid');
      const dayMap = element.getData('dayMap');

      elDayGrid.querySelectorAll('.selection').forEach(item => item.remove());

      if (!this.set.range) {
         this.enableConfirmButton(this.selectedDate.from !== false);
         this.elConfirm.querySelector('.date + .selected-date').innerHTML = this.selectedDate.from !== false ? this.selectedDate.from.toGermanDate(true, false) : '';

         if (this.selectedDate.from !== false) {
            for (let isoDate in dayMap) {
               if (isoDate === this.selectedDate.from.isoDate()) {
                  let elSelection = elDayGrid.createElement('div', 'selection single');
                  elSelection.style.gridArea = `${dayMap[isoDate].row} / ${dayMap[isoDate].col}`;
               }
            }
         }

      }
      else {
         this.enableConfirmButton(this.selectedDate.from !== false && this.selectedDate.to !== false);
         this.elConfirm.querySelector('.date-from + .selected-date').innerHTML = this.selectedDate.from !== false ? this.selectedDate.from.toGermanDate(true, false) : '';
         this.elConfirm.querySelector('.date-to + .selected-date').innerHTML = this.selectedDate.to !== false ? this.selectedDate.to.toGermanDate(true, false) : '';

         for (let isoDate in dayMap) {
            let time = 0;
            if (this.selectedDate.from && this.selectedDate.from.isoDate() == isoDate) {
               let elSelection = elDayGrid.createElement('div', 'selection single');
               elSelection.style.gridArea = `${dayMap[isoDate].row} / ${dayMap[isoDate].col}`;
            }
            else if (this.selectedDate.to && this.selectedDate.to.isoDate() == isoDate) {
               let elSelection = elDayGrid.createElement('div', 'selection single');
               elSelection.style.gridArea = `${dayMap[isoDate].row} / ${dayMap[isoDate].col}`;
            }
            if (this.selectedDate.from && this.selectedDate.to && isoDate > this.selectedDate.from.isoDate() && isoDate <= this.selectedDate.to.isoDate()) {
               let elSelection = elDayGrid.createElement('div', 'selection between');
               elSelection.style.gridArea = `${dayMap[isoDate].row} / ${dayMap[isoDate].col}`;
            }

         }

      }

      element.set

   }

   onSelect(elMonth, date) {

      if (!this.enabled) return;

      if (this.monthScroller.dragging) return;

      if (!this.set.range) {
         this.selectedDate.from = date;
         this.set.onSelect(date);
      }
      else {
         // Wenn ein bereits selektiertes Datum gewählt wurde: deselektieren.
         if (this.selectedDate.from && this.selectedDate.from.getTime() === date.getTime()) {
            this.selectedDate.from = false;
         }
         else if (this.selectedDate.to && this.selectedDate.to.getTime() === date.getTime()) {
            this.selectedDate.to = false;
         }
         // Andernfalls: Termin als Start- oder Endepunkt des Ranges setzen (je nachdem, welcher frei ist).
         else if (this.selectedDate.from === false) {
            this.selectedDate.from = date;
         }
         else if (this.selectedDate.to === false) {
            this.selectedDate.to = date;
         }
         // Wenn der gewählte Termin den Startpunkt nach vorne oder den Endpunkt nach hinten verschieben würde: dies tun.
         else if (this.selectedDate.from.getTime() > date.getTime()) {
            this.selectedDate.from = date;
         }
         else if (this.selectedDate.to.getTime() < date.getTime()) {
            this.selectedDate.to = date;
         }
         // Andernfalls liegt der Termin innerhalb eines bereits selektierten Ranges: das nähere Range-Ende verschieben
         else {
            if (Math.abs((date.getTime())-this.selectedDate.from.getTime()) < Math.abs((date.getTime())-this.selectedDate.to.getTime())) {
               this.selectedDate.from = date;
            }
            else {
               this.selectedDate.to = date;
            }
         }


         // Wenn nur das Enddatum gesetzt ist oder beide Daten gesetzt sind und das Enddatum vor dem Startdatum liegt: tauschen
         //if (this.selectedDate.to && this.selectedDate.from && this.selectedDate.to.getTime() < this.selectedDate.from.getTime()) {
         if ((this.selectedDate.to && !this.selectedDate.from) || (this.selectedDate.to && this.selectedDate.to.getTime() < this.selectedDate.from.getTime())) {
            [this.selectedDate.to, this.selectedDate.from] = [this.selectedDate.from, this.selectedDate.to];
         }

         this.set.onSelect(this.selectedDate.from, this.selectedDate.to);

      }

      this.renderSelection(elMonth);

   }

   enableConfirmButton(enabled) {
      this.elConfirm.querySelector('.btn-confirm').disabled = !enabled;
   }

   getSelection() {
      if (!this.selectedDate.to) this.selectedDate.to = this.selectedDate.from;
      return this.set.range ? this.selectedDate : this.selectedDate.from;
   }

   getElement() {
      return this.elMain;
   }

   setEnabled(enabled) {
      this.enabled = enabled;
      this.elMain.style.filter = enabled ? '' : 'grayscale(1)';
   }


}
